<!-- 题干组件 -->
<template>
  <div class="topicNav" :id="'ques-'+rankNum">
      <div class="tit">
          <div class="font-size14 topicType c-256CF4">
              [{{queType}}]
          </div>
          <div class="font-size18 font-medium">{{ rankNum }}、</div>
          <div class="font-size18 topicContent auto-grow" v-if="orginObj.Content"
               v-html="orginObj.Content"></div>
      </div>
      <slot></slot>
  </div>
</template>
<script>
export default {
    name: "Question",
    data() {
        return {
            arr: [],
        }
    },
    props: {
        orginObj: {
            type: Object,
            require: true
        }
    },
    computed: {
        queType() {
            const types = {
                1: "单选题",
                2: "多选题",
                3: "填空题",
                4: "判断题",
                5: "回答题",
                6: "复合题",
            }
            return types[this.orginObj.SubjectType];
        },
        rankNum() {
            return this.orginObj.rankNum || this.orginObj.RankNum
        }
    },
}
</script>
<style scoped lang="less">
.topicNav {
    display: flex;
    margin-top: 30px;
    margin-left: 34px;
    margin-right: 31px;
    justify-content: space-between;

    .tit {
        display: flex;
        .topicType {
            flex-shrink: 0;
            margin-right: 13px;
            line-height: 28px;
        }

        .topicContent {
        }
    }
}
</style>
